//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Field from '../../../../components/field';

export default ({
  extends: Field,
  props: {
    errorMessageColor: {
      validator: (value) => {
        return ['white', 'red', 'pink'].includes(value);
      },
      default: 'red',
    },
  },
});
